import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs/internal/BehaviorSubject";
import {BuilderGeneratedPageSectionI} from "../builder-v2.interface";
import {Subject} from "rxjs/internal/Subject";

@Injectable({
  providedIn: 'root'
})
export class CanvasPageInteractionsService {
  openSectionEdit: BehaviorSubject<{
    pageId: number;
    sectionId: number;
    section: BuilderGeneratedPageSectionI
  }> = new BehaviorSubject<{
    pageId: number;
    sectionId: number;
    section: BuilderGeneratedPageSectionI;
  }>(null);
  openAddSection: BehaviorSubject<{ pageId: number, sectionId: number }> = new BehaviorSubject<{
    pageId: number;
    sectionId: number
  }>(null);
  openAddPage: BehaviorSubject<{ pageId: number }> = new BehaviorSubject<{
    pageId: number;
  }>(null);
  sectionValueChange: Subject<{
    pageId: number,
    sectionId: number,
    section: BuilderGeneratedPageSectionI
  }> = new Subject<{ pageId: number, sectionId: number, section: BuilderGeneratedPageSectionI }>();
  generateSection: Subject<{
    pageId: number;
    sectionId: number;
    section: BuilderGeneratedPageSectionI;
    type: 'title' | 'description' | 'new' | 'enhance'
  }> = new Subject<{
    pageId: number;
    sectionId: number;
    section: BuilderGeneratedPageSectionI;
    type: 'title' | 'description' | 'new' | 'enhance'
  }>();
  sectionIsGenerating: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  newPageTitle: Subject<string> = new Subject<string>();

  closeAll() {
    this.openSectionEdit.next(null);
    this.openAddSection.next(null);
    this.openAddPage.next(null);
  }

  constructor() {
  }
}
